import React, { useEffect } from 'react';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/it';

// third-party
import useConfig from 'hooks/useConfig';

// load locales files
import translationEN from 'utils/locales/en.json';
import translationIT from 'utils/locales/it.json';

// ==============================|| LOCALIZATION ||============================== //

interface LocalsProps {
    children: React.ReactElement;
}

const resources = {
    en: {
        translation: translationEN
    },
    it: {
        translation: translationIT
    }
};

i18next.use(initReactI18next).init({
    resources,
    fallbackLng: 'it',
    keySeparator: false,
    interpolation: {
        escapeValue: false
    }
});

const Locales = ({ children }: LocalsProps) => {
    const { locale } = useConfig();

    moment.locale(locale);

    useEffect(() => {
        i18next.init({
            lng: locale
        });
    }, [locale]);

    return children;
};

export default Locales;
